import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { BookingsContainer } from 'src/features/bookings/containers/bookings';
import { meilisearchSearchSchema } from 'src/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute('/_layout/tenant/bookings/_layout/')({
  component: BookingsContainer,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
